import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant'
import Vuex from 'vuex'
import store from './vuex/store'
import 'vant/lib/index.css'
Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(Vant);
new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
